import { z } from 'zod';
import { tenantInsightSchema } from '@/types/tenantInsights';
import { DAMNodeType, ancestorsSchema } from '@/types/tree';

const favoriteNodeSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string(),
  ancestors: ancestorsSchema,
});

const favoriteSchema = z.object({
  id: z.string(),
  node: favoriteNodeSchema,
  type: z.nativeEnum(DAMNodeType),
});

export const getHomeSchema = z.object({
  insights: tenantInsightSchema,
  favorites: z.array(favoriteSchema).nullable().optional(),
});

export type Favorite = z.infer<typeof favoriteSchema>;
